// 9fbef606107a605d69c0edbcd8029e5d
import { getPlaceSiteId } from '@tcp/core/src/utils';
import { executeStatefulAPICall } from '../../handler';
import endpoints from '../../endpoints';
import PAGES from '../../../constants/pages.constants';

const setDate = (value) => {
  // dateString *HAS* to be in this format "YYYY-MM-DDTHH:MM:SS"
  const dateParam = value.split(/[\s-:]/);
  const year = dateParam[0];
  const month = dateParam[1];
  const day = dateParam[2]?.split('T')[0];
  return `${month}/${day}/${year}`;
};

export const getPointsHistoryData = () => {
  const payload = {
    webService: endpoints.getPointsHistory,
    header: {
      fromPage: PAGES.CHECKOUT_PAGE,
      siteId: getPlaceSiteId(),
    },
  };
  return executeStatefulAPICall(payload).then((res) => {
    if (!res.body) {
      throw new Error('res body is null');
      // TODO - Set API Helper to filter if error exists in response
    }

    let pointsHistory = [];
    if (res.body.data) {
      pointsHistory = res.body.data.pointsHistoryData.map(
        ({
          pointAwardedDate,
          pointTransactionType,
          pointsEarned,
          transactionDate,
          transactionType,
          transactionTypeName,
        }) => ({
          pointAwardedDate,
          pointTransactionType,
          pointsEarned,
          transactionDate: setDate(transactionDate),
          transactionType,
          transactionTypeName,
        })
      );
    }
    return pointsHistory;
  });
};

export default {
  getPointsHistoryData,
};
